import { NamedComplexEnumItem } from '../utils/complexEnum/NamedComplexEnumItem'

export class PathnameItem<
  ID extends string = string,
  Name extends string = string,
  Pathname extends string = string
> extends NamedComplexEnumItem<ID, Name> {
  /**
   * the value that should be used in the address bar to access this resource
   * client side
   */
  readonly pathname: Pathname
  /**
   * any old {@link pathname} values to check when resolving a url
   */
  readonly deprecatedPathnames: string[]
  /**
   * @see {@link ComplexEnumItem}
   * @see {@link PathnameItemConstructor}
   */
  constructor({
    pathname,
    deprecatedPathnames,
    ...simple
  }: PathnameItemConstructor<ID, Name, Pathname>) {
    super(simple)
    this.pathname = pathname
    this.deprecatedPathnames = deprecatedPathnames ?? []
  }
}

export type PathnameItemConstructor<
  ID extends string,
  Name extends string,
  Pathname extends string
> = Pick<PathnameItem<ID, Name, Pathname>, 'id' | 'pathname' | 'name'> &
  Partial<Pick<PathnameItem, 'deprecatedPathnames'>>
